









import { Component, Vue } from 'vue-property-decorator';3
import SupportPage from "@/components/supportPage/SupportPage.vue";

@Component({
  components: {
    SupportPage
  }
})
export default class Support extends Vue {}
